const LabelMapper = {
  assets: 'assets',
  cash: 'Cash',
  receivables: 'Receivables',
  ppe: 'Property, Plant and Equipment',
  intangibles: 'Intangibles',
  deferredTaxAssets: 'Deferred tax assets',
  otherAssets: 'Other assets',

  avgConsumptionCharge: 'avgConsumptionCharge',
  avgServiceCharge: 'avgServiceCharge',
  capacity: 'capacity',
  dams: 'dams',
  entityType: 'entityType',

  expenses: 'expenses',
  assetImpairmentDecrement: 'Asset impairment/decrement',
  assetDepreciation: 'Asset depreciation',
  suppliesAndServices: 'Supplies and services',
  financeCost: 'Finance cost',
  employeeBenefitsExpense: 'Employee benefits expense',
  otherExpenses: 'Other expenses',

  liabilities: 'liabilities',
  employeeBenefits: 'Employee benefits',
  borrowings: 'Borrowings',
  provisions: 'Provisions',
  payables: 'Payables',
  deferredTaxLiabilities: 'Deferred tax liabilities',
  otherLiabilities: 'Other liabilities',

  name: 'name',

  revenue: 'revenue',
  waterSupply: 'Water supply',
  waterDistribution: 'Water distribution',
  developerContributions: 'Developer contributions',
  grantsAndSubsidies: 'Grants and subsidies',
  assetIncrement: 'Asset increment',
  otherRevenue: 'Other revenue',

  shareholderReturns: 'Shareholder returns',
  taxEquivalent: 'Tax equivalent',
  dividendParticipationReturn: 'Dividend/participation return',

  storageLevel: 'storageLevel',
  MIWB: 'Mount Isa Water Board',
  GAWB: 'Gladstone Area Water Board',
};

const EntityLabelMapper = {
  plural: {
    'Bulk water supplier': 'Bulk water suppliers',
    'Distributor-retailers': 'Distributor-retailers',
    'Category 1 water board': 'Category 1 water boards',
    Coastal: 'coastal councils',
    'Rural/Regional': 'Rural/Regional councils',
    'Rural/Remote': 'Rural/Remote councils',
    Indigenous: 'Indigenous councils',
    SEQ: 'South East Queensland councils',
    Resources: 'resources councils',
  },
  singular: {
    'Bulk water supplier': 'Bulk water supplier',
    'Distributor-retailers': 'Distributor-retailer',
    'Category 1 water board': 'Category 1 water board',
    Coastal: 'a coastal council',
    'Rural/Regional': 'a Rural/Regional council',
    'Rural/Remote': 'a Rural/Remote council',
    Indigenous: 'an Indigenous council',
    SEQ: 'a South East Queensland council',
    Resources: 'a resources council',
    MIWB: 'Mount Isa Water Board',
    GAWB: 'Gladstone Area Water Board',
    Seqwater: 'Seqwater',
    Sunwater: 'Sunwater',
    'Urban Utilities': 'Urban Utilities',
    Unitywater: 'Unitywater',
  },
  mapBanner: {
    Coastal: 'Coastal',
    'Rural/Regional': 'Rural/Regional',
    'Rural/Remote': 'Rural/Remote',
    Indigenous: 'Indigenous',
    SEQ: 'South East Queensland',
    Resources: 'Resources',
  },
  header: {
    Coastal: 'Coastal',
    'Rural/Regional': 'Rural/Regional',
    'Rural/Remote': 'Rural/Remote',
    Indigenous: 'Indigenous councils',
    SEQ: 'SE Queensland',
    Resources: 'Resources councils',
  },
};

export const entityLabelMatcher = (str, type) => {
  if (str.includes('Other')) {
    str = 'Other Entities';
  }

  let label;
  switch (type) {
    case 'plural':
      label = EntityLabelMapper.plural[str];
      break;
    case 'header':
      label = EntityLabelMapper.header[str];
      break;
    case 'map-banner':
      label = EntityLabelMapper.mapBanner[str];
      break;
    default:
      label = EntityLabelMapper.singular[str];
  }

  if (!label) {
    throw Error('Missing label for: ' + str);
  }
  return label;
};

export const labelMatcher = (str) => {
  const label = LabelMapper[str];
  if (!label) {
    return str;
  }
  return label;
};



// WEBPACK FOOTER //
// ./src/helpers/label-mapper.js